import * as React from "react";
import Spinner from '../common/spinner';
import { connect } from "react-redux";
import CustomLink from "../common/CustomLink";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

/**
 * Container component for the Terms Agreement page.
 * 
 */
class TermsAgreement extends React.Component {
    constructor(props) {
        super(props);
        this.handleAcceptClick = this.handleAcceptClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleOKClick = this.handleOKClick.bind(this);
        this.popstate = this.popstate.bind(this);
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            this.popstate();
            window.addEventListener('popstate', this.popstate);            
        }
        logUI("MBHWeb.UI.TermsAgreement.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined' && this.popstate)
            window.removeEventListener('popstate', this.popstate);
    }

    popstate() {
        if (typeof window !== 'undefined') {
            window.history.pushState(null, document.title, window.location.href);
        }
    }

    handleAcceptClick(event) {
        event.preventDefault();
        //debugger;
        const { acknowledgeTerms, termsVersion, showInsuranceForm } = this.props;
        acknowledgeTerms(termsVersion);
        logUI("MBHWeb.TermsConditions.Accept", new Date(), Tools.getURLPath());
        try {
            if (showInsuranceForm) {
                logUI("MBHWeb.TermsConditions.LoadInsuranceForm", new Date(), Tools.getURLPath());
                this.props.history.push("/captureinsurance");
            } else {
                //debugger;

                this.props.history.push("/");
            }
        }
        catch (e) {
            //debugger;

            window.location.href = "/";
        }
    }

    handleCancelClick(event) {
        event.preventDefault();
        this.props.logout("You must accept the terms and conditions to access this site.");
        logUI("MBHWeb.TermsConditions.Cancel", new Date(), Tools.getURLPath());
    }

    handleOKClick(event) {
        try {
            event.preventDefault();
            this.props.clearRedirectURL();
            logUI("MBHWeb.TermsConditions.OK", new Date(), Tools.getURLPath());
            //debugger;

            this.props.history.push("/");
        }
        catch (e) {
            //debugger;

            window.location.href = "/";
        }

    }


    render() {
        const { userHasAccepted, terms, termsObject } = this.props;
        let homePage = { to: { pathname: "/" } };

        return (
            <div className="container-fluid terms-agreement-container">
                <div className="row terms-agreement__header align-items-center">
                    <div className="col-12 maxWidth-content text-center">
                        <CustomLink linkProps={{ ...homePage }}>
                            <img alt="MyBSWHealth" className="img-fluid" src="/images/mybswlogo.svg" />
                        </CustomLink>
                    </div>
                </div>
                <div className="row terms-agreement__body">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-center maxWidth-content">
                                <h1 className="page-heading">Terms and Conditions</h1>
                                {/* H2 heading displays after successfully accepted terms */}
                                {/* <h2 className="subheading-success">Thanks, you're all set!</h2> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                {termsObject &&
                                    <div className="terms-text">
                                        <div dangerouslySetInnerHTML={{ __html: termsObject.MyBSWHealth }} />
                                        <div dangerouslySetInnerHTML={{ __html: termsObject.MyChart }} />
                                    </div>
                                }
                                {/* Terms text becomes hidden after successfully accepted terms 
                                */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center maxWidth-content">
                                {/* Accept and decline buttons become hidden after user declines or accepts terms */}
                                {!userHasAccepted ?
                                    <div className="row">
                                        <div className="col-6 col-sm-4 offset-sm-2 form-group">
                                            <a className="btn edit-btn" href="#" onClick={(e) => this.handleCancelClick(e)}>DECLINE</a>
                                        </div>
                                        <div className="col-6 col-sm-4 form-group">
                                            <a className="btn btn-primary" href="#" onClick={(e) => this.handleAcceptClick(e)}>ACCEPT</a>
                                        </div>
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-12 col-sm-4 offset-sm-4 form-group">
                                            <a className="btn btn-primary" href="#" onClick={(e) => this.handleOKClick(e)}>OKAY</a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    //debugger;
    return {
        terms: state.session.terms,
        userHasAccepted: state.session.userHasAccepted,
        termsVersion: state.session.version,
        IsLoggedIn: state.domain.li,
        UserName: state.domain.un,
        history: state.session.history,
        termsObject: state.session.terms ? JSON.parse(state.session.terms) : null,        
        showInsuranceForm : state.session.showInsuranceForm
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        acknowledgeTerms: (version) => {
            //debugger;
            dispatch({
                type: types.ACCEPT_TERMS_AND_CONDITIONS,
                VersionID: version
            });

        },
        logout: (message) => {
            dispatch({
                type: types.LOGOUT,
                logoutMessage: message
            });
        },
        clearRedirectURL: () => {
            dispatch({
                type: types.CLEAR_REDIRECT_URL,
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsAgreement);

